import React, { useState } from 'react';

const ROLE_COLORS = {
  buyer:  { bg: '#e0f2fe', color: '#0369a1' },
  seller: { bg: '#f0fdf4', color: '#166534' },
};

const STATUS_COLORS = {
  completed:  { bg: '#f0fdf4', color: '#166534' },
  cancelled:  { bg: '#fef2f2', color: '#991b1b' },
  expired:    { bg: '#fef9c3', color: '#854d0e' },
};

function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
  });
}

function TransactionCard({ tx }) {
  const role   = ROLE_COLORS[tx.role]   || ROLE_COLORS.buyer;
  const status = STATUS_COLORS[tx.status] || STATUS_COLORS.completed;

  return (
    <div style={{
      background: 'var(--surface-card)',
      border: '1px solid var(--gray-200, #e9ecef)',
      borderRadius: 'var(--radius-lg, 12px)',
      padding: '14px 16px',
      display: 'flex',
      gap: 14,
      alignItems: 'flex-start',
      boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
    }}>
      {/* Left accent bar */}
      <div style={{ width: 4, borderRadius: 4, background: tx.role === 'seller' ? '#166534' : '#0369a1', alignSelf: 'stretch', flexShrink: 0 }} />

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8, flexWrap: 'wrap' }}>
          <span style={{ fontWeight: 600, fontSize: '0.9rem', color: 'var(--gray-900, #212529)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '60%' }}>
            {tx.listingTitle || 'Untitled listing'}
          </span>
          <span style={{ fontSize: '0.78rem', color: 'var(--gray-500, #adb5bd)', whiteSpace: 'nowrap', marginTop: 1 }}>
            {formatDate(tx.completedAt)}
          </span>
        </div>

        <div style={{ display: 'flex', gap: 6, marginTop: 6, flexWrap: 'wrap' }}>
          <span style={{ ...role, padding: '2px 9px', borderRadius: 20, fontSize: '0.75rem', fontWeight: 600 }}>
            {tx.role === 'buyer' ? 'Buyer' : 'Seller'}
          </span>
          <span style={{ ...status, padding: '2px 9px', borderRadius: 20, fontSize: '0.75rem', fontWeight: 600 }}>
            {tx.status ? tx.status.charAt(0).toUpperCase() + tx.status.slice(1) : 'Completed'}
          </span>
          <span style={{ background: 'var(--maroon-light, rgba(136,28,28,0.07))', color: 'var(--maroon, #881c1c)', padding: '2px 9px', borderRadius: 20, fontSize: '0.75rem', fontWeight: 600 }}>
            Direct
          </span>
        </div>

        <div style={{ marginTop: 6, fontSize: '0.82rem', color: 'var(--gray-600, #6c757d)' }}>
          {tx.role === 'buyer' ? 'Seller' : 'Buyer'}:{' '}
          <span style={{ fontWeight: 500, color: 'var(--gray-800, #343a40)' }}>{tx.otherPartyName || 'Unknown'}</span>
        </div>
      </div>
    </div>
  );
}

export default function TransactionHistory({ transactions = [] }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <section style={{ marginBottom: '2rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h2 className="section-title" style={{ margin: 0 }}>
          Transaction History
          <span className="section-count">({transactions.length})</span>
        </h2>
        {transactions.length > 0 && (
          <button
            onClick={() => setExpanded(e => !e)}
            style={{
              padding: '5px 14px', background: 'transparent', border: '1.5px solid var(--maroon-border, rgba(136,28,28,0.25))',
              borderRadius: 'var(--radius-sm, 6px)', color: 'var(--maroon, #881c1c)', cursor: 'pointer',
              fontSize: '0.82rem', fontWeight: 600, fontFamily: 'inherit', transition: 'background 150ms',
            }}
            onMouseOver={e => e.currentTarget.style.background = 'var(--maroon-light, rgba(136,28,28,0.07))'}
            onMouseOut={e => e.currentTarget.style.background = 'transparent'}
          >
            {expanded ? 'Hide' : 'Show'} History
          </button>
        )}
      </div>

      {/* Animated expand */}
      <div style={{ overflow: 'hidden', maxHeight: expanded ? '2000px' : 0, transition: 'max-height 0.4s ease' }}>
        {transactions.length > 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {transactions.map((tx) => (
              <TransactionCard key={tx.id || tx._id} tx={tx} />
            ))}
          </div>
        ) : null}
      </div>

      {transactions.length === 0 && (
        <div style={{
          textAlign: 'center', padding: '2.5rem 2rem', background: 'var(--surface-panel)',
          borderRadius: 'var(--radius-lg)', border: '1px solid var(--border-subtle)',
          color: 'var(--text-muted)',
        }}>
          <div style={{ fontWeight: 600, color: 'var(--text-strong)' }}>No transactions yet</div>
          <div style={{ fontSize: '0.85rem', marginTop: '0.25rem' }}>Completed deals will appear here.</div>
        </div>
      )}
    </section>
  );
}
